import {combineReducers} from 'redux';
import accountinfo from './accountinfo/reducer';
import updateaccount from './updateaccount/reducer';

export default combineReducers({
  accountinfo,
  updateaccount,
});
